let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');

class SubmitByIcon {

  constructor(name, submit, wrapper) {
    this.$submitIcon = null;
    this.name = name;
    this.$submit = submit;
    this.$wrapper = wrapper;
    $(window).resize(() => this.handleState()).trigger('resize');
  }

  handleState() {
    if(
      breakpoints.current === 'large' ||
      breakpoints.current === 'xlarge'
    ) {
      if(this.$submitIcon === null) {
        this.addSubmit();
      }
    } else if(this.$submitIcon !== null) {
      this.removeSubmit();
    }
  }

  addSubmit() {
    var className;
    var markup;

    if (this.name === "filter-by") {
      className = "dashboard__filter-form__apply-btn";
      markup = "<a class='" + className + "' href='javascript: void 0;'>Apply</a>";
    }
    else {
      className = "dashboard__filter-form__submit-icon--" + this.name;
      markup = "<a class='dashboard__filter-form__submit-icon " + className + "' href='javascript: void 0;'>Search</a>";
    }

    this.$wrapper.find('.dashboard__filter-form__submit-icon').remove();
    this.$wrapper.append(markup);

    this.$submitIcon = $(`.` + className);


    this.$submitIcon.bind('click', () => {
      this.$submit.trigger('click');
    });
  }

  removeSubmit() {
    this.$submitIcon.unbind('click')
    this.$submitIcon.remove();
    this.$submitIcon = null;
  }

}

module.exports = SubmitByIcon;
